// src/RawItemCategoryForm.js ver 01 - Nov 14 2025 6:33 pm - SB105
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useAuth } from './App';
import * as rawItemCategoryService from './api/rawItemCategoryService';
import { ApiError } from './api/apiClient';

const initialCategoryState = {
    RawItemCategoryName: '',
    Status: 'Active', // NEW ver 01: Default status
    Comments: '',    // NEW ver 01: Default empty string for comments
};

// NEw: ver 01 - Allowed Status values (for frontend dropdown)
const categoryStatuses = ['Active', 'Not-Active'];

function RawItemCategoryForm() {
    // const { tenantId, id: rawItemCategoryId } = useParams();
    const { id: rawItemCategoryId } = useParams();
    const navigate = useNavigate();
    const isEditing = Boolean(rawItemCategoryId);
    const auth = useAuth();

    const [formData, setFormData] = useState(initialCategoryState);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [categoryNameError, setCategoryNameError] = useState(null);

    const tenantId = auth.userProfile?.SubsCoDocId; // re-added ver01. existing in ver 00a

    console.log(`tenantId = ${tenantId}; rawItemCategoryId = ${rawItemCategoryId}`)

    useEffect(() => {
        const fetchData = async () => {
            if (!tenantId) {
                setError("Tenant ID missing in URL.");
                setLoading(false);
                return;
            }

            if (isEditing) {
                setLoading(true);
                setError(null);
                try {
                    const token = await auth.getIdToken();
                    if (!token) {
                        setError("Authentication required. Please log in.");
                        setLoading(false);
                        return;
                    }
                    console.log(`2tenantId = ${tenantId}; 2rawItemCategoryId = ${rawItemCategoryId}`)
                    const data = await rawItemCategoryService.getRawItemCategoryById(tenantId, rawItemCategoryId, token);
                    if (data) {
                        setFormData(data);
                    } else {
                        setError("Raw Item Category not found.");
                        navigate(`/raw-item-categories/tenant/${tenantId}`);
                    }
                } catch (err) {
                    console.error("Error fetching raw item category from Cloud Function: ", err);
                    setError(`Failed to load raw item category details: ${err.message}`);
                } finally {
                    setLoading(false);
                }
            } else {
                setLoading(false);
            }
        };
        fetchData();
    }, [tenantId, rawItemCategoryId, isEditing, navigate, auth]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setCategoryNameError(null);

        if (!tenantId) {
            setError("Tenant ID missing. Cannot save raw item category.");
            return;
        }
        if (!formData.RawItemCategoryName || formData.RawItemCategoryName.trim() === '') {
            setCategoryNameError("Category Name is required.");
            return;
        }
        
        try {
            const token = await auth.getIdToken();
            if (!token) {
                setError("Authentication required. Please log in.");
                return;
            }

            const payload = { ...formData };

            console.log(`tenantId = ${tenantId}; rawItemCategoryId = ${rawItemCategoryId}`)
            if (isEditing) {
                await rawItemCategoryService.updateRawItemCategory(tenantId, rawItemCategoryId, payload, token);
                alert("Raw Item Category updated successfully!");
            } else {
                await rawItemCategoryService.addRawItemCategory(tenantId, payload, token);
                alert("Raw Item Category created successfully!");
            }
            navigate(`/raw-item-categories`);
        } catch (err) {
            console.error("Error saving raw item category via Cloud Function:", err);
            if (err instanceof ApiError && err.status === 409) {
                setCategoryNameError(`Error: ${err.message}`);
                setError(null);
            } else {
                setError(`Failed to save raw item category: ${err.message}`);
            }
        }
    };

    if (loading) return <p>Loading raw item category details...</p>;
    if (error) return <p style={{ color: 'red' }}>Error: {error}</p>;
    if (!tenantId) return <p className="container" style={{ color: 'red' }}>Error: Tenant ID is required to add/edit raw item category.</p>;


    return (
        <div className="container form-container">
            <h2>{isEditing ? `Edit Raw Item Category (Tenant: ${tenantId})` : `Add New Raw Item Category (Tenant: ${tenantId})`}</h2>
            <form onSubmit={handleSubmit}>

                {isEditing && formData.SeqId && ( // New ver 01: Display SeqId if editing
                    <div className="form-group">
                        <label>Sequential ID</label>
                        <input type="text" name="SeqId" value={formData.SeqId || ''} disabled />
                    </div>
                )}


                <div className="form-group">
                    <label>Category Name</label>
                    <input
                        type="text"
                        name="RawItemCategoryName"
                        value={formData.RawItemCategoryName}
                        onChange={handleChange}
                        required
                    />
                    {categoryNameError && <p style={{ color: 'red', fontSize: '0.85em' }}>{categoryNameError}</p>}
                </div>

                <div className="form-group"> {/* NEW ver 01: Status dropdown */}
                    <label>Status</label>
                    <select name="Status" value={formData.Status} onChange={handleChange} required>
                        {categoryStatuses.map(status => (
                            <option key={status} value={status}>{status}</option>
                        ))}
                    </select>
                </div>

                <div className="form-group"> {/* NEW ver 01: Comments input */}
                    <label>Comments</label>
                    <textarea name="Comments" value={formData.Comments} onChange={handleChange} rows="3"></textarea>
                </div>



                {isEditing && formData.DateAdded && (
                    <div className="form-group">
                        <label>Date Added</label>
                        <input type="text" value={new Date(formData.DateAdded._seconds * 1000).toLocaleString()} disabled />
                    </div>
                )}
                {isEditing && formData.DateLastModified && (
                    <div className="form-group">
                        <label>Date Last Modified</label>
                        <input type="text" value={new Date(formData.DateLastModified._seconds * 1000).toLocaleString()} disabled />
                    </div>
                )}

                <button type="submit">Save Category</button>
            </form>
        </div>
    );
}

export default RawItemCategoryForm;